import api from '../../api/api';

const auth = {
    supplierRegister(content) {
        return new Promise((resolve, reject) => {
            api.post('/supplier/register/', content, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    activateAccount(token) {
        return new Promise((resolve, reject) => {
            api.get(`/authentication/verify_email?token=${token}`, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    verifyToken(uidb64,token) {
        return new Promise((resolve, reject) => {
            api.get(`/authentication/password-reset/${uidb64}/${token}/`, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    setPassword(content) {
        return new Promise((resolve, reject) => {
            api.patch(`/authentication/password-reset-complete`, content, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    login(content) {
        return new Promise((resolve, reject) => {
            api.post('/auth/login/', content, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    verifyTwoFA(content) {
        return new Promise((resolve, reject) => {
            api.post(`/authentication/tfa/verify/`, content, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    resendTwoFA(content) {
        return new Promise((resolve, reject) => {
            api.get(`/authentication/tfa/resend/`, content, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    resetPassword(content) {
        return new Promise((resolve, reject) => {
            api.post('/authentication/request-reset-email/', content, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    requestAccountActivation(content) {
        return new Promise((resolve, reject) => {
            api.post('/authentication/account/activation/', content, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    countryLocations(countryName) {
        return new Promise((resolve, reject) => {
            api.get(`/common/countries/${countryName}/locations/`, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },

    logs(page, dataPerPage) {
        return new Promise((resolve, reject) => {
            api.get(`/authentication/user_logs/?page=${page}&page_size=${dataPerPage}`, (data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
}

export default auth
